<template lang="pug">
	.editEmployeesContainer
		section.section
			//- Add Employees (write:employees needed)
			b-button(type="is-dark", @click="currentEmployee = null; addingEmployee = true;", v-if="permissions.indexOf('write:employees') > -1") Add Employee
			p.spacer
			b-field(label="Department")
				b-select(v-model="selectedOrg", :disabled="userOrgs.length < 2")
					option(v-for="org in userOrgs", :key="org", :value="org") {{ org }}
			p.spacer
			//- Table of Employees (read:employees needed)
			b-table(:data="employeeData", :mobile-cards="false", bordered, striped, narrowed, hoverable, v-if="permissions.indexOf('read:employees') > -1")
				template(slot-scope="props")
					b-table-column(field="org", label="Org", width="50")
						span {{ props.row.org }}
					b-table-column(field="tag", label="ID", width="100")
						span {{ props.row.tag }}
					b-table-column(field="name", label="Name")
						span {{ props.row.name }}
					b-table-column(field="notes", label="Notes")
						span {{ props.row.notes }}
					//- Column to add picture for face recognition (write:employees needed)
					b-table-column(label="Picture", v-if="permissions.indexOf('write:employees') > -1")
						span
							a(@click="addPicture(props.row.org, props.row._id)")
								b-icon(:type="props.row.face ? 'is-dark' : 'is-link'", icon="camera", pack="fas")
					//- Column to edit employee data (write:employees needed)
					b-table-column(label="Edit", v-if="permissions.indexOf('write:employees') > -1")
						span
							a(@click="editEmployee(props.row._id)")
								b-icon(type="is-dark", icon="pencil-alt", pack="fas")
						span
							a(@click="confirmDeleteEmployee(props.row.org, props.row._id)")
								b-icon(type="is-danger", icon="trash", pack="fas")

		//- Modal container for the EditEmployeeModal component
		b-modal(:active.sync="addingEmployee", has-modal-card, trap-focus)
			EditEmployeeModal(:currentEmployee="currentEmployee")

		//- Modal container for the EditEmployeeFaceModal component
		b-modal(:active.sync="editingEmployeeFace", has-modal-card, trap-focus)
			EditEmployeeFaceModal(:currentEmployee="currentEmployee")
</template>

<style lang="scss" scoped>
	//
</style>

<script>
	import { mapState, mapGetters } from "vuex";

	export default {
		components: {
			EditEmployeeModal: () => import("@/components/EditEmployeeModal.vue"),
			EditEmployeeFaceModal: () => import("@/components/EditEmployeeFaceModal.vue")
		},
		data() {
			return {
				addingEmployee: false, // open the modal that contains the EditEmployeeModal component
				editingEmployeeFace: false, // open the modal that contains the EditEmployeeFaceModal component
				currentEmployee: null, // details of the selected employee to edit that prefills the EditEmployeeModal component's form
				selectedOrg: null // which organization's employees to show in the Table of Employees
			};
		},
		computed: {
			...mapState(["refreshedUser", "permissions"]),
			...mapGetters(["employees", "userOrgs"]),
			// The employees filtered by the current selected organization (this.selectedOrg)
			employeeData() {
				let fullEmployeeData = JSON.parse(JSON.stringify(this.employees));
				return fullEmployeeData.filter((em) => em.org === this.selectedOrg);
			}
		},
		methods: {
			// Ask to delete employee before deleting employee
			confirmDeleteEmployee(org, employeeID) {
				this.$buefy.dialog.confirm({
					message: "Are you sure you want to delete this employee?",
					onConfirm: () => this.deleteEmployee(org, employeeID)
				});
			},
			// Delete employee -- user will be asked to confirm first with a Buefy confirm dialog
			deleteEmployee(org, employeeID) {
				this.$store
					.dispatch("editEmployee", { action: "delete", org, employeeID })
					.then(() => {
						this.$buefy.snackbar.open({
							duration: 3000,
							message: "Successfully removed.",
							type: "is-success",
							position: "is-top-right",
							queue: false
						});
					})
					.catch((err) => {
						// DEMO
						if (err === "DEMO: Cannot delete this demo user.") {
							this.$buefy.snackbar.open({
								duration: 3000,
								message: err,
								type: "is-warning",
								position: "is-top-right",
								queue: false
							});
							return;
						}

						console.log(err);
						this.$buefy.snackbar.open({
							duration: 3000,
							message: "Unknown error occured.",
							type: "is-danger",
							position: "is-top-right"
						});
					});
			},
			// Edit employee by opening the EditEmployeeModal (via addingEmployee=true) then prefilling the fields
			editEmployee(employeeID) {
				this.currentEmployee = JSON.parse(
					JSON.stringify(
						this.employeeData.find((em) => {
							return em._id === employeeID;
						})
					)
				);
				this.addingEmployee = true; // open modal
			},
			addPicture(org, employeeID) {
				this.currentEmployee = JSON.parse(
					JSON.stringify(
						this.employeeData.find((em) => {
							return em._id === employeeID;
						})
					)
				);
				this.editingEmployeeFace = true; // open edit face modal
			}
		},
		mounted() {
			if (!this.refreshedUser) {
				this.$store.dispatch("fetchUserData");
			}

			// Select default organization in dropdown
			this.selectedOrg = this.userOrgs[0];
		}
	};
</script>
